document.addEventListener("DOMContentLoaded", function() {
    setTargetForDomain("flipsnack.com"),
    setTargetForDomain("agrigrodealer.com"),
    setTargetForDomain("cdn.shopify.com");
    function setTargetForDomain(domain) {
        var links = document.querySelectorAll('a[href*="' + domain + '"]');
        links.forEach(function(link) {
            link.setAttribute("target", "_blank")
        })
    }
}),
$(document).ready(function() {
    function adjustIframeHeight() {
        var iframe = $(".gfiframe")[0]
          , innerDoc = iframe.contentDocument || iframe.contentWindow.document
          , contentHeight = $(innerDoc).height();
        $(iframe).height(contentHeight)
    }
    adjustIframeHeight(),
    $(".gfiframe").on("load", function() {
        adjustIframeHeight()
    })
});

